<div fxLayout="row" fxLayoutGap="1rem">
  <div fxFlex="66" fxLayout="column" fxLayoutAlign="space-around start">
    <span>Wir haben für Sie eine Bedienungsanleitung zusammengestellt.</span>
    <span>Hier finden Sie hilfreiche Erklärungen und Beispiele wie Sie Redispatch relevante Anlagen erstellen oder importieren können.</span>
  </div>
  <div fxFlex="33"
    fxLayout="column"
    fxLayoutAlign="space-around center"
    [class.available]="fileExists"
    [class.unavailable]="!fileExists"
    (click)="download()">
    <div class="icon-container" >
      <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
      @if (!fileExists) {
        <mat-icon color="warn" class="warning-icon">error</mat-icon>
      }
    </div>
    @if (fileExists) {
      <span class="download-link available">{{file?.name}}</span>
    }
    @if (!fileExists) {
      <span class="download-link">Bedienungsanleitung nicht vorhanden</span>
    }
  </div>
</div>
